






import { Vue, Component, Prop } from 'vue-property-decorator';
import { authModule } from '@/auth/modules';

@Component({
    name: 'CallbackComponent',
})
export default class CallbackComponent extends Vue {
    private mounted() {
        // console.debug('redirected');
        authModule.handleAuthentication();
    }
}
